// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__nmg-M","footer_container":"Footer_footer_container__SlJYY","p":"Footer_p__ylMVv"};